class priceController {
    static calculatePrice(fanPrice, enginePrice, priceMultiplier) {
        if (fanPrice && enginePrice && priceMultiplier)
            return parseFloat(((fanPrice * priceMultiplier.fan_ratio) + (enginePrice * priceMultiplier.motor_ratio) + parseFloat(priceMultiplier.constant))).roundTo(2);
        else return null;
    }

    static calculateDiscount(price, discountObj, specialDiscount = 0) {
        let discount = 0;
        let additionalDiscount = 0;

        if(isFinite(discountObj.offerDiscountGivenByTheAdministrator) && parseFloat(discountObj.offerDiscountGivenByTheAdministrator) > 0){
            discount = discountObj.offerDiscountGivenByTheAdministrator;
        }
        else if (isFinite(discountObj.userDiscountValue) && parseFloat(discountObj.userDiscountValue) > 0) {
            discount = discountObj.userDiscountValue;
        }

        if(isFinite(discountObj.additionalDiscount) && parseFloat(discountObj.additionalDiscount) > 0 && specialDiscount == 0){
            additionalDiscount = discountObj.additionalDiscount;
        }

        if (!isFinite(price))
            price = 0;

        return parseFloat(price * (1 - additionalDiscount / 100) * (1 - specialDiscount / 100) * (1 - discount / 100)).toFixed(2);
    }

    static calculateDiscountRaw(price, discountObj) {
        let discount = 0;
        let additionalDiscount = 0;

        if(isFinite(discountObj.offerDiscountGivenByTheAdministrator) && parseFloat(discountObj.offerDiscountGivenByTheAdministrator) > 0){
            discount = discountObj.offerDiscountGivenByTheAdministrator;
        }
        else if (isFinite(discountObj.userDiscountValue) && parseFloat(discountObj.userDiscountValue) > 0) {
            discount = discountObj.userDiscountValue;
        }

        if(isFinite(discountObj.additionalDiscount) && parseFloat(discountObj.additionalDiscount) > 0){
            additionalDiscount = discountObj.additionalDiscount;
        }

        if (!isFinite(price))
            price = 0;

        return Math.round(price * (1 - additionalDiscount / 100) * (1 - discount / 100) * 1000) / 1000;
    }

    static convertWithThousandSeparator(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
}

export { priceController }